import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import { getUserFromCookies } from "../../../utils/Auth";
import Warning from "../../../assets/images/icons/warning.svg";
import { filterFeaturedProducts } from "../../../redux/feature/featureActions";
import { getOutletFromCookies, getTeamFromCookies } from "../../../utils/Auth";

export default function FilterFeatureDropDown(props) {
  const { payLoad, isFilterOpen, setFilterState } = props;
  const dispatch = useDispatch();
  const outlet = getOutletFromCookies();
  const team = getTeamFromCookies();
  const { isLoading, filtering } = useSelector((state) => state.feature);

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    featured_amount: "",
    featured_paid: "",
    start_date: "",
    end_date: "",
  });
  const { featured_amount, featured_paid, start_date, end_date } = data;

  const user = getUserFromCookies();
  let business = Object.keys(user?.groups)[0];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleReset = async () => {
    setData({
      featured_amount: "",
      featured_paid: "",
      start_date: "",
      end_date: "",
    });
    await dispatch(filterFeaturedProducts(payLoad, 1));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    let newData = { ...data, ...payLoad };
    if (team !== "administrator") {
      newData.business_id = business;
      newData.restaurant_id = outlet?.id;
    }
    if (featured_amount || featured_paid || start_date || end_date) {
      setErrorMsg(false);
      try {
        const response = await dispatch(filterFeaturedProducts(newData, 1));
        if (response?.status === "success") {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div data-test="couponModal">
      <form className="py-5 mt-4 px-5">
        <div className="grid grid-cols-1">
          <Input.Number
            title={"Food Price"}
            name="featured_amount"
            id="featured_amount"
            value={featured_amount}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter food amount"
            onChange={handleChange}
          />

          <Input.Select
            title={"Status"}
            name="featured_paid"
            id="featured_paid"
            defaultValue={featured_paid}
            htmlFor={"featured_paid"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="E.g: 200"
            onChange={handleChange}
          >
            <option>Select Status</option>
            <option value={1}>Paid</option>
            <option value={0}>Unpaid</option>
          </Input.Select>

          <Input.DatePicker
            title={"Start Date"}
            name="start_date"
            id="start_date"
            htmlFor={"start_date"}
            defaultValue={start_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
          <Input.DatePicker
            title={"End Date"}
            name="end_date"
            id="end_date"
            htmlFor={"end_date"}
            defaultValue={end_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
        </div>
        <div className="py-8 grid grid-cols-2 gap-6 text-center">
          <Button.Secondary
            disabled={isLoading}
            title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
            className="px-4"
            onClick={handleReset}
            type="button"
          />
          <Button.Primary
            disabled={filtering}
            title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
            className="px-4"
            onClick={handleSubmit}
            type="button"
          />
        </div>
        {errorMsg && (
          <div className="flex gap-1 -mt-2">
            <img src={Warning} alt="warning" />
            <p>No value to filter by</p>
          </div>
        )}
      </form>
    </div>
  );
}
